export const option_rooms = {
    emptyBtn: false,
    submitBtn: false,
    column: [
        { span: 4, label: "左", prop: "left", value: 0 },
        { span: 4, label: "上", prop: "top", value: 0 },
        { span: 4, label: "宽度", prop: "width", value: 100 },
        { span: 4, label: "高度", prop: "height", value: 100 },
    ],
}
export const entities = [
    {
        type: 'boundary',
        name: "边界",
        pointVisable: false,
        checked: true,
        form_type: 0
    },
    {
        type: 'entrance',
        name: "入口",
        pointVisable: false,
        checked: true,
        form_type: 0
    },
    {
        type: 'hallway',
        name: "玄关",
        pointVisable: false,
        checked: false
    },
    {
        type: 'room1',
        name: "卧室1",
        pointVisable: false,
        checked: false
    },
    {
        type: 'room2',
        name: "卧室2",
        pointVisable: false,
        checked: false
    },
    {
        type: 'room3',
        name: "卧室3",
        pointVisable: false,
        checked: false
    },
    {
        type: 'room4',
        name: "卧室4",
        pointVisable: false,
        checked: false
    },
    {
        type: 'living',
        name: "客厅",
        pointVisable: false,
        checked: false
    },
    {
        type: 'dinner',
        name: "餐厅",
        pointVisable: false,
        checked: false
    },
    {
        type: 'kitchen',
        name: "厨房",
        pointVisable: false,
        checked: false
    },
    {
        type: 'storeroom',
        name: "储藏室",
        pointVisable: false,
        checked: false
    },
    {
        type: 'toilet_main',
        name: "卫生间1",
        pointVisable: false,
        checked: false
    },
    {
        type: 'toilet2',
        name: "卫生间2",
        pointVisable: false,
        checked: false
    },
    {
        type: 'toilet3',
        name: "卫生间3",
        pointVisable: false,
        checked: false
    },
    {
        type: 'toilet4',
        name: "卫生间4",
        pointVisable: false,
        checked: false
    },
    {
        type: 'black1',
        name: "黑体1",
        pointVisable: false,
        checked: false
    },
    {
        type: 'black2',
        name: "黑体2",
        pointVisable: false,
        checked: false
    },
    {
        type: 'black3',
        name: "黑体3",
        pointVisable: false,
        checked: false
    },
    {
        type: 'black4',
        name: "黑体4",
        pointVisable: false,
        checked: false
    },
    {
        type: 'white_m1',
        name: "白体1",
        pointVisable: false,
        checked: false
    },
    {
        type: 'white_m2',
        name: "白体2",
        pointVisable: false,
        checked: false
    },
    {
        type: 'white_m3',
        name: "白体3",
        pointVisable: false,
        checked: false
    },
    {
        type: 'white_m4',
        name: "白体4",
        pointVisable: false,
        checked: false
    },
    {
        type: 'white_south',
        name: "白体南",
        pointVisable: false,
        checked: false
    },
    {
        type: 'white_north',
        name: "白体北",
        pointVisable: false,
        checked: false
    },
    {
        type: 'white_third',
        name: "白体侧",
        pointVisable: false,
        checked: false
    },
    {
        type: 'white_fourth',
        name: "白体侧",
        pointVisable: false,
        checked: false
    }
]
export const colors = {
    'boundary': '#FFE27D',
    'entrance': 'whitesmoke',
    'hallway': 'whitesmoke',
    'white_south': 'whitesmoke',
    'white_north': 'whitesmoke',
    'white_third': 'whitesmoke',
    'white_fourth': 'whitesmoke',
    'white_m1': 'whitesmoke',
    'white_m2': 'whitesmoke',
    'white_m3': 'whitesmoke',
    'white_m4': 'whitesmoke',
    'black1': 'darkgrey',
    'black2': 'darkgrey',
    'black3': 'darkgrey',
    'black4': 'darkgrey',
    'room1': '#F3A169',
    'room2': '#F3A169',
    'room3': '#F3A169',
    'room4': '#F3A169',
    'storeroom': '#B1BABB',
    'living': '#FFE27D',
    'dinner': '#C5D5AE',
    'toilet_main': '#6483A6',
    'toilet2': '#90AEC4',
    'toilet3': '#90AEC4',
    'toilet4': '#90AEC4',
    'kitchen': '#80A6AF',
    'storage': 'lightsteelblue'
}
export const default_room_relation = {
    "white_m2boundary": "1",
    "white_m2white_south": "-1",
    "white_m2white_north": "-1",
    "white_m2white_third": "-1",
    "white_m2white_fourth": "-1",
    "white_m1boundary": "1",
    "white_m1white_south": "-1",
    "white_m1white_north": "-1",
    "white_m1white_third": "-1",
    "white_m1white_fourth": "-1",
    "white_m3boundary": "1",
    "white_m3white_south": "-1",
    "white_m3white_north": "-1",
    "white_m3white_third": "-1",
    "white_m3white_fourth": "-1",
    "white_m4boundary": "1",
    "white_m4white_south": "-1",
    "white_m4white_north": "-1",
    "white_m4white_third": "-1",
    "white_m4white_fourth": "-1",
    "room1boundary": "1",
    "room1white_south": "-1",
    "room1white_m1": "-1",
    "room2boundary": "1",
    "room2white_south": "-1",
    "room2white_north": "-1",
    "room2white_third": "-1",
    "room2white_fourth": "-1",
    "room2white_m1": "-1",
    "room2white_m2": "-1",
    "room3boundary": "1",
    "room3white_south": "-1",
    "room3white_north": "-1",
    "room3white_third": "-1",
    "room3white_fourth": "-1",
    "room3white_m1": "-1",
    "room3white_m2": "-1",
    "room4boundary": "1",
    "room4white_south": "-1",
    "room4white_north": "-1",
    "room4white_third": "-1",
    "room4white_fourth": "-1",
    "room4white_m1": "-1",
    "room4white_m2": "-1",
    "livingboundary": "1",
    "livingwhite_south": "-1",
    "livingwhite_m1": "-1",
    "kitchenboundary": "1",
    "kitchenwhite_south": "-1",
    "kitchenwhite_north": "-1",
    "kitchenwhite_third": "-1",
    "kitchenwhite_fourth": "-1",
    "kitchenwhite_m1": "-1",
    "kitchenwhite_m2": "-1",
    "toilet_mainboundary": "1",
    "toilet2boundary": "1"
}
export const default_path_relation = {
    "livingentrance": "1", "livingroom1": "1", "livingroom2": "1", "livingroom3": "1", "livingroom4": "1", "livingliving": "-1", "livingdinner": "1", "livingkitchen": "1", "dinnerentrance": "1", "dinnerliving": "1", "dinnerdinner": "-1",
    "dinnerkitchen": "1", "livingstoreroom": "0", "dinnerstoreroom": "0"
}

export const default_room_count = {
    "white_m1": 1200, "white_m2": 1200, "white_m3": 1200, "white_m4": 1200, "living": 1200, "room1": 1200, "room2": 1200, "room3": 1200, "room4": 1200, "kitchen": 1000, "toilet_main": 800, "toilet2": 600, "hallway": 400, "dinner": 200
}

let dicTypes = {}
for (let i of entities) {
    dicTypes[i.type] = i.name;
}
export const dic_types = dicTypes;

export const commit_rooms = (data, room_info, left = 100, top = 100) => {
    let y = 0;
    if (room_info) {
        data.filter((e) => {
            if (e.form_type == 0 && e.top + e.height > y) {
                y = e.top + e.height;
            }
            if (room_info[e.type] && e.form_type == 1) {
                e.left = room_info[e.type].center_x;
                e.top = room_info[e.type].center_y;
                e.width = room_info[e.type].width;
                e.height = room_info[e.type].depth;
                e.form_type = 0;
            }
        })
    }
    y = y / 30;
    data.filter((e) => {
        e.left /= 30;
        e.top /= 30;
        e.left += left;
        e.top -= top;
        e.height /= 30;
        e.width /= 30;
        e.top = y - (e.top + e.height);
    })
}

export const default_rooms = [
    {
        "type": "boundary",
        "form_type": 0,
        "left": 530,
        "top": 100,
        "width": 240,
        "height": 330,
        "point_x": 0,
        "point_y": 0
    },
    {
        "type": "entrance",
        "form_type": 0,
        "left": 510,
        "top": 200,
        "width": 40,
        "height": 40,
        "point_x": 0,
        "point_y": 0
    },
    {
        "type": "black1",
        "form_type": 0,
        "left": 530,
        "top": 100,
        "width": 20,
        "height": 170,
        "point_x": 0,
        "point_y": 0
    },
    {
        "type": "white_south",
        "form_type": 0,
        "left": 530,
        "top": 430,
        "width": 240,
        "height": 40,
        "point_x": 0,
        "point_y": 0
    },
    {
        "type": "white_north",
        "form_type": 0,
        "left": 530,
        "top": 60,
        "width": 240,
        "height": 40,
        "point_x": 0,
        "point_y": 0
    },
    {
        "type": "white_m1",
        "form_type": 1,
        "left": 0,
        "top": 0,
        "width": 100,
        "height": 100,
        "point_x": "-1",
        "point_y": "-1",
        "count": 1200,
        "min_width": "1200",
        "max_width": "3600",
        "min_height": "1200",
        "max_height": "3600",
        "min_area": "1",
        "max_area": "6"
    },
    {
        "type": "white_m2",
        "form_type": 1,
        "left": 0,
        "top": 0,
        "width": 100,
        "height": 100,
        "point_x": "-1",
        "point_y": "-1",
        "count": 1200,
        "min_width": "1200",
        "max_width": "3600",
        "min_height": "1200",
        "max_height": "3600",
        "min_area": "1",
        "max_area": "6"
    },
    {
        "type": "dinner",
        "form_type": 1,
        "left": -1,
        "top": -1,
        "width": 10,
        "height": 10,
        "point_x": -1,
        "point_y": -1,
        "min_width": "2100",
        "max_width": "3600",
        "min_height": "2100",
        "max_height": "3600",
        "min_area": "4",
        "max_area": "12",
        "point_visable": false,
        "count": 200
    },
    {
        "type": "kitchen",
        "form_type": 1,
        "left": -1,
        "top": -1,
        "width": 10,
        "height": 10,
        "point_x": -1,
        "point_y": -1,
        "min_width": "1200",
        "max_width": "3600",
        "min_height": "1200",
        "max_height": "3600",
        "min_area": "3",
        "max_area": "10",
        "point_visable": false,
        "count": 1000
    },
    {
        "type": "toilet_main",
        "form_type": 1,
        "left": -1,
        "top": -1,
        "width": 10,
        "height": 10,
        "point_x": -1,
        "point_y": -1,
        "min_width": "1200",
        "max_width": "3000",
        "min_height": "1200",
        "max_height": "3000",
        "min_area": "2",
        "max_area": "8",
        "point_visable": false,
        "count": 800
    },
    {
        "type": "room1",
        "form_type": 1,
        "left": -1,
        "top": -1,
        "width": 10,
        "height": 10,
        "point_x": -1,
        "point_y": -1,
        "min_width": "2700",
        "max_width": "4200",
        "min_height": "3000",
        "max_height": "4800",
        "min_area": "9",
        "max_area": "20",
        "point_visable": false,
        "count": 1200
    },
    {
        "type": "room2",
        "form_type": 1,
        "left": -1,
        "top": -1,
        "width": 10,
        "height": 10,
        "point_x": -1,
        "point_y": -1,
        "min_width": "2400",
        "max_width": "4500",
        "min_height": "2400",
        "max_height": "4500",
        "min_area": "7",
        "max_area": "17",
        "point_visable": false,
        "count": 1200
    },
    {
        "type": "room3",
        "form_type": 1,
        "left": -1,
        "top": -1,
        "width": 10,
        "height": 10,
        "point_x": -1,
        "point_y": -1,
        "min_width": "2400",
        "max_width": "4500",
        "min_height": "2400",
        "max_height": "4500",
        "min_area": "7",
        "max_area": "15",
        "point_visable": false,
        "count": 1200
    },
    {
        "type": "room4",
        "form_type": 1,
        "left": -1,
        "top": -1,
        "width": 10,
        "height": 10,
        "point_x": -1,
        "point_y": -1,
        "min_width": "2400",
        "max_width": "4500",
        "min_height": "2400",
        "max_height": "4500",
        "min_area": "7",
        "max_area": "15",
        "point_visable": false,
        "count": 1200
    },
    {
        "type": "toilet2",
        "form_type": 1,
        "left": -1,
        "top": -1,
        "width": 10,
        "height": 10,
        "point_x": -1,
        "point_y": -1,
        "min_width": "1200",
        "max_width": "3000",
        "min_height": "1200",
        "max_height": "3000",
        "min_area": "2",
        "max_area": "8",
        "point_visable": false,
        "count": 600
    },
    {
        "type": "toilet3",
        "form_type": 1,
        "left": -1,
        "top": -1,
        "width": 10,
        "height": 10,
        "point_x": -1,
        "point_y": -1,
        "min_width": "1200",
        "max_width": "3000",
        "min_height": "1200",
        "max_height": "3000",
        "min_area": "2",
        "max_area": "8",
        "point_visable": false,
        "count": 600
    },
    {
        "type": "toilet4",
        "form_type": 1,
        "left": -1,
        "top": -1,
        "width": 10,
        "height": 10,
        "point_x": -1,
        "point_y": -1,
        "min_width": "1200",
        "max_width": "3000",
        "min_height": "1200",
        "max_height": "3000",
        "min_area": "2",
        "max_area": "8",
        "point_visable": false,
        "count": 600
    },
    {
        "type": "storeroom",
        "form_type": 1,
        "left": -1,
        "top": -1,
        "width": 10,
        "height": 10,
        "point_x": -1,
        "point_y": -1,
        "min_width": "1200",
        "max_width": "3000",
        "min_height": "1200",
        "max_height": "3000",
        "min_area": "2",
        "max_area": "8",
        "point_visable": false,
        "count": 600
    },
    {
        "type": "living",
        "form_type": 1,
        "left": -1,
        "top": -1,
        "width": 10,
        "height": 10,
        "point_x": -1,
        "point_y": -1,
        "min_width": "3600",
        "max_width": "4800",
        "min_height": "3600",
        "max_height": "4800",
        "min_area": "9",
        "max_area": "24",
        "point_visable": false,
        "count": 1200
    }
]